<div class="row">
  <div class="col">
    <div *ngIf="observationsLoading" class="text-center">
      <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
    </div>
    <div *ngIf="!observationsLoading" >
    <p-table  [totalRecords]="observations?.length" #dt [value]="observations" styleClass="p-datatable-striped  p-datatable-responsive-eca"
             [scrollable]="!isOnMobile &&    observations?.length > 5" scrollHeight="500px" dataKey="id" [responsive]="true" [columns]="columns"
             [globalFilterFields]="['observedOn.dateTime', 'notesAsHtml','summaryInfo','observedBy','followUpOn.dateTime','observationTypeString']">
        <ng-template pTemplate="caption" *ngIf="showCaption">
          <div class="row hide-on-small-screens" *ngIf="showWarningMessage" ><div class="col-md-auto ">
            <div class="alert alert-info">
              Please note that if you are adding an observation relating to a particular Training Record, then you should open the training record in first tab and add it there.
            </div>
          </div></div>
          <div class="row d-flex justify-content-between align-items-center">
            <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
              <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                <div class="col-auto">
                  <h5 class="eca-primary-text">
                    <span *ngIf="observations "> {{ observations.length }}</span>
                    {{tableTitle}}
                  </h5>
                </div>
                <div class="col-auto">
                  <app-eca-ghost-btn (btnClicked)="createObservation()" [btnText]="addButtonText" *ngIf="allowedOperations?.canInsert && showAddButton"
                                     btnIcon="plus-circle" btnType="success"></app-eca-ghost-btn>
                </div>
              </div>
            </div>
            <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
              <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-6">
                     <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                             <input pInputText type="text" class="form-control" id="ctrlObservationsSearchInput" style="min-width: 150px"
                                    placeholder="Search All"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')">
                     </span>
                </div>
                <div class="col-auto">
                  <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                </div>
              </div>
            </div>
          </div>

        </ng-template>
      <ng-template pTemplate="header" >
        <tr>
          <th style="width: 14%;" pSortableColumn="observedBy">Observer
            <p-sortIcon field="observedBy"></p-sortIcon>
          </th>
          <th style="width: 14%;" pSortableColumn="observedOn.dateTime">Date Observed
            <p-sortIcon field="observedOn.dateTime"></p-sortIcon>
          </th>
          <th style="width: 14%;" pSortableColumn="followUpOn.dateTime">Followup
            <p-sortIcon field="followUpOn.dateTime"></p-sortIcon>
          </th>
          <th style="width: 14%;" pSortableColumn="observationTypeString">Type
            <p-sortIcon field="observationTypeString"></p-sortIcon>
          </th>

          <th style="width: 14%;" pSortableColumn="summaryInfo">Information
            <p-sortIcon field="summaryInfo"></p-sortIcon>
          </th>

          <th style="width: 20%;" pSortableColumn="notesAsHtml">Notes
            <p-sortIcon field="notesAsHtml"></p-sortIcon>
          </th>

          <th style="font-weight: bold; width: 10%;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-observation let-columns="columns"  style="margin: 15px;">
        <tr>
          <td *ngFor="let col of columns">

            <span class="p-column-title">{{col.header}}: </span>
            <label>
                <span *ngIf="col.type=== 'text'">
                  {{observation[col.field]}}
            </span>
              <span *ngIf="col.type === 'date'">
                {{observation[col.field]?.dateTime | date:'dd/MM/yyyy'}}
            </span>
              <span *ngIf="col.type === 'type'">
                {{ObservationTypeString[ observation[col.field]]}}
            </span>
            </label>
            <label *ngIf="col.type === 'html'" [innerHTML]="observation[col.field] | ellipsis:70">

            </label>

          </td>
          <td>
            <div class="text-center">
              <app-eca-row-menu (viewBtnClicked)="viewObservation(observation)"
                                [dropdownVisible]="allowedOperations?.canDelete"
                                [rowMenuItems]="rowMenuItems"
                                [contextItem]="observation">
              </app-eca-row-menu>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </div>
</div>
